/**
 * CR-7258 — the "whose order is this?" line in a Purchasing modal header.
 *
 * A modal header is the only part of a modal that survives a tab change. Where
 * the parties are named on a panel instead (a Customer Information card, a
 * Customer field on a Detail tab) they vanish the moment the user moves to
 * another tab, and on a multi-site account there is then nothing on screen
 * saying which of the user's own plants the order belongs to.
 *
 * @param parts - Ordered fragments, customer before supplier to follow the
 *   direction of the relationship. Empty, whitespace-only and missing values
 *   are dropped rather than rendered as a dangling separator: several of these
 *   fields are optional on their TypeScript types, and a header is the last
 *   place that should be able to show "undefined".
 * @returns The joined label, or an empty string if nothing survived.
 */
export function formatPartySubtitle(
  ...parts: Array<string | null | undefined>
): string {
  return parts
    .filter((part): part is string => Boolean(part && part.trim()))
    .map((part) => part.trim())
    .join(PARTY_SEPARATOR);
}

/**
 * A middle dot, not " - ".
 *
 * Customer names here are site-qualified and routinely contain a hyphen of
 * their own ("... - TCZEW", "Acme – Aerospace – France | Toulouse"), so a
 * hyphen separator cannot be told apart from part of a name and leaves the
 * reader guessing where one party ends and the next begins.
 */
export const PARTY_SEPARATOR = ' · ';
